//
//
//
//
//
//
//
import menu from '@/menu/modules/demo-playground';
export default {
  data: function data() {
    return {
      menu: menu,
      banner: {
        title: 'PLAYGROUND',
        subTitle: '在这里可以测试一些 D2Admin 的系统功能'
      }
    };
  }
};